<template>
<!-- Main row -->
   <v-card>
      <v-card-text>
     		 <v-layout v-if="incoming && acceptcall">
           		 <v-flex  xs12 sm12 md12 class="pl-2 text-xs-center"  >
                 	<v-btn small flat color="green"    @click="rejectcall()" >  End Call  </v-btn>
				  </v-flex>
            </v-layout>
            <v-layout row wrap v-else>
 		  <!--<v-flex  xs12 sm12 md12>  
          {{ userid }}
          </v-flex>-->
          <v-flex  xs3 sm3 md3>   
                 <v-menu offset-y>
                    <v-btn style="min-width: 7px;font-size: 20px;"  slot="activator" flat small>  <div :class="'flag flag-' + countryCodeimg" style="font-size: 20px;"></div> +<span class="country-code">{{ countryCode }}</span>  </v-btn>
                
                  <v-list>
                    <v-list-tile  v-for="(country, index) in countries"  :key="index"  @click="selectCountry(country)"  >
                      <v-list-tile-title> <span>{{ country.name }} (+{{ country.cc }})</span></v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
          </v-flex>    
          <v-flex  xs7 sm7 md7>      
              <!-- Telephone input field -->
              <input type="tel" class="form-control num" v-model="currentNumber"    placeholder="555-666-7777" style="border: 0px solid #ced4da; background-color:transparent;font-size: 20px; font-weight: 400;padding-left: 0px;margin-top: 3px; ">
         </v-flex>    
         <v-flex  xs2 sm2 md2>  
      		<span  class="backremove"  @click="removeDigit()"> <i class="material-icons">backspace</i></span>
         </v-flex>    
            
            
            
               <v-flex  xs4 sm4 md4 v-for="n in 9"   :key="n" class="p-2 text-xs-center">
               		<v-avatar color="red" @click="sendDigit(n)" style="cursor:pointer">
                      <span class="white--text headline">{{ n }}</span>
                    </v-avatar>
               </v-flex>
               
               <v-flex  xs4 sm4 md4  class="p-2 text-xs-center">
               		<v-avatar color="red" @click="sendDigit('*')" style="cursor:pointer">
                      <span class="white--text headline">*</span>
                    </v-avatar>
               </v-flex>
                <v-flex  xs4 sm4 md4  class="p-2 text-xs-center">
               		<v-avatar color="red" @click="sendDigit('0')" style="cursor:pointer">
                      <span class="white--text headline">0</span>
                    </v-avatar>
               </v-flex>
                <v-flex  xs4 sm4 md4  class="p-2 text-xs-center">
               		<v-avatar color="red" @click="sendDigit('#')" style="cursor:pointer">
                      <span class="white--text headline">#</span>
                    </v-avatar>
               </v-flex>
               
               <v-flex  xs12 sm12 md12 class="pl-2 text-xs-center">
               	<v-btn icon   @click="toggleCall()"  style="cursor:pointer"    :color="onPhone===false ? 'green' : 'red'" :disabled="!validPhone">
                    <v-icon v-if="onPhone==true" color="white" >mdi mdi-phone-hangup</v-icon>
                    <v-icon v-else  color="white" >mdi mdi-phone</v-icon>
                  </v-btn>
            
                  <v-btn icon  aria-label="Favorite" v-if="onPhone" @click="toggleMute">
                     <i class="v-icon mdi   theme--light white--text" :class="[ muted ? 'mdi-microphone-off': 'mdi-microphone' ]"></i> 
                  </v-btn  >
                  <v-btn icon  aria-label="Favorite" v-else disabled>
                    <i class="v-icon mdi   theme--light white--text mdi-microphone-off"  ></i> 
                  </v-btn  >
               </v-flex>
               
                 <v-flex  xs12 sm12 md12 class="pl-2 text-xs-center">
                 	<div class="log" v-cloak>{{ log }}</div>
                 </v-flex>
               	<v-flex  xs12 sm12 md12 class="pl-2 text-xs-center">
                 	<div class="log" v-cloak>  {{ cstatus }}</div>
                 </v-flex>
                 <v-flex  xs12 sm12 md12 class="pl-2 text-xs-center">
                 	<div class="log" v-cloak> Duration: {{ callduration}}</div>
                 </v-flex>
                 
                 
               
            </v-layout>
            
   </v-card-text>
  </v-card>
<!-- /.row (main row) -->
</template>

<script>
import io from 'socket.io-client';

//import Twilio from 'twilio'
const Twilio = require('twilio-client');

import Countryphoneselect from '../Includes/Countryphoneselect.vue';

export default {
  name: 'Dialer',
  data() {
    return {
       // Outgoing call country code
	    socket:"",
	    dcountry:{"name":"India","cc":"91","code":"in"},	
		countryCode: '91',
		countryCodeimg: 'in',
		currentNumber: '6379112113',
		muted: false,
		cstatus:'',
		onPhone: false,
		//log: 'Connecting...',
		countries: [
		  { name: 'United States', cc: '1', code: 'us' },
		  { name: 'Great Britain', cc: '44', code: 'gb' },
		  { name: 'Colombia', cc: '57', code: 'co' },
		  { name: 'Ecuador', cc: '593', code: 'ec' },
		  { name: 'Estonia', cc: '372', code: 'ee' },
		  { name: 'Germany', cc: '49', code: 'de' },
		  { name: 'Hong Kong', cc: '852', code: 'hk' },
		  { name: 'Ireland', cc: '353', code: 'ie' },
		  { name: 'Singapore', cc: '65', code: 'sg' },
		  { name: 'Spain', cc: '34', code: 'es' },
		  { name: 'Brazil', cc: '55', code: 'br' },
		  { name: 'India', cc: '91', code: 'in' },
		],
		connection: null 
    }
  },
  created: function(){
   	 /*setTimeout(() => {
					  this.setupDevice (); 
				},3000)*/
	this.socket=io(`${window.socketendpoint}`);
				
  },components: {
   	Countryphoneselect
  },mounted() {	
		//this.getProfile();
		
		
		
  },computed: {
     userid () {
	   if(this.$store.state.user){
			if(typeof this.$store.state.user.uid!=='undefined'){
				return this.$store.state.user.uid;
			}else{
				return '';
			}
		}else{
				return '';
			}
	},
	// Computed property to validate the current phone number
    validPhone: function() {
      return /^([0-9]|#|\*)+$/.test(this.currentNumber.replace(/[-()\s]/g,''));
    },callduration: function () {
      // `this` points to the vm instance
        var dur='0.00';
	    Twilio.Device.connect(function(handl) {
		//  this.log = 'Connected';
		console.log('connect',handl);  
		});
	
	 return dur;
    },cstatus2: function () {
       
		var dur='';
		/*var outgoingConnection = Twilio.Device.connect(params);
		outgoingConnection.on('ringing', function() {
			 console.log('Ringing...');
			 dur = 'Ringing...';
		});*/
	     
	
	 return dur;
    },
	  dfrom: {
		get: function () {
		  return this.$store.state.dfrom
		},
		set: function (newValue3) {
		  this.$store.state.dfrom = newValue3
		}
	  },
	  dtomenuid: {
		get: function () {
		  return this.$store.state.dtomenuid
		},
		set: function (newValue3) {
		  this.$store.state.dtomenuid = newValue3
		}
	  },
	  log: {
		get: function () {
		  return this.$store.state.log
		},
		set: function (newValue3) {
		  this.$store.state.log = newValue3
		}
	  },
	  incoming: {
		get: function () {
		  return this.$store.state.incoming
		},
		set: function (newValue3) {
		  this.$store.state.incoming = newValue3
		}
	  },
	  inconn: {
		get: function () {
		  return this.$store.state.inconn
		},
		set: function (newValue3) {
		  this.$store.state.inconn = newValue3
		}
	  },
	  acceptcall: {
		get: function () {
		  return this.$store.state.acceptcall
		},
		set: function (newValue3) {
		  this.$store.state.acceptcall = newValue3
		}
	  },
    },
	watch: {
		dfrom(v){
			if(v){
				setTimeout(() => {
					  this.setupDevice (); 
				},2000)
			}
		 },
		
    },methods: {
    // Handle country code selection
	 accept3 (){
	  console.log('accept:',this.inconn);
	    if(this.inconn){
			this.inconn.accept();
		}
	 },rejectcall (){
		console.log('reject:',this.inconn);
		Twilio.Device.disconnectAll();
		this.currentNumber='';
		this.incoming=false
		this.inconn=null;
		this.acceptcall=false;
		 this.log = 'Call End!';
	 },
	 setupnew (){
		var self = this;
		if(self.dfrom!=''){
			//console.log('setupDevice',self.dfrom);
			// Fetch Twilio capability token from our Node.js server
			var u=`${window.endpoint}/inbrowser/newtoken/`+self.userid+`/`+self.dfrom; //console.log('turl:',u);
			//var u=`${window.endpoint}/inbrowser/token`; 
			
			$.getJSON(u).done(function(data) {
				 // console.log('data.token:',data.token);
				  if(data.token){
					 Twilio.Device.setup(data.token);
				  }else{
					 self.log = 'Could not fetch token, see console.log';
				  }
			}).fail(function(err) {
			  console.log(err);
			  self.log = 'Could not fetch token, see console.log';
			});
		 }
	 },setupDevice (){
	
		var self = this;
		if(self.dfrom!=''){
			 
			self.setupnew();
			
			// Configure event handlers for Twilio Device
			Twilio.Device.disconnect(function(handl) {
			  self.onPhone = false;
			  self.connection = null;
			  self.log = 'Call ended.';
			  console.log('disconnect',handl);  
			});
		
			Twilio.Device.ready(function() {
			  self.log = 'Connected';
			});
			
			Twilio.Device.incoming(function (conn) {
			  console.log('incoming',conn);  
			  self.log = 'Incoming connection from ' + conn.parameters.From;
			  self.incoming=true
			  self.inconn=conn;
			  
			  //conn.accept(); // accept the incoming connection and start two-way audio
			  
			  /*$("#incoming-accept").on("click", function() {
			    self.log = 'Incoming call connected with ' + conn.parameters.From;
				conn.accept();
			  });
			  $("#incoming-reject").on("click", function() {
			   self.log = 'Incoming call dis-connected with ' + conn.parameters.From;
				conn.cancel();
				 self.incoming=false
			  });*/
			  
			  /*$( "#dialog-confirm" ).dialog({
				resizable: false,
				modal: true,
				autoOpen: false,
				buttons: {
				  "Accept": function() {
					conn.accept();
					self.log = 'Call answered!';
					$( this ).dialog( "close" );
				  },
				  "Reject": function() {
					conn.reject();
					self.log = 'Call rejected! Awaiting next call.';
					$( this ).dialog( "close" );
				  }
				}
			  });
			  this.socket.emit("incoming",connection.parameters.From);*/
			  
			});
			
			Twilio.Device.offline(function(device) {
				 console.log("Twilio.Device is offline, so getting a new token");
				 self.log = 'Offline';
				 self.setupnew();
			});
			
			Twilio.Device.error(function(error) {
				 console.log(error.message);
				 console.log("Twilio.Device is offline due to an error, so getting a new token");
				 self.log = 'Offline';
				 self.setupnew();
			});
			
			
		}
	},
	
    onInputPhone ($event, index){
		 
		//this.addcontact.phonelists[index] =$event;
		 console.log('index',index,'event',JSON.stringify($event))
		//this.addcontact.phonelists[index].country = $event.country;
		//this.addcontact.phonelists[index].phone = $event.number;
		
		this.countryCode = $event.country.code;
		this.countryCodeimg  = $event.country.cc;
		this.currentNumber = $event.phone;
		
		
		
	 },selectCountry: function(country) {
      this.countryCode = country.cc;
	  this.countryCodeimg = country.code;
    },

    // Handle muting
    toggleMute: function() {
      this.muted = !this.muted;
      Twilio.Device.activeConnection().mute(this.muted);
    },

    // Make an outbound call with the current number,
    // or hang up the current call
    toggleCall: function() {
      if (!this.onPhone) {
        this.muted = false;
        this.onPhone = true;
        // make outbound call with current number
        var n = '+' + this.countryCode + this.currentNumber.replace(/\D/g, '');
        this.connection = Twilio.Device.connect({ number: n });
        this.log = 'Calling ' + n;
		
		/*this.connection.on('ringing', function() {
			 console.log('Ringing...');
			 this.cstatus  = 'Ringing...';
		});*/
		
		//add to logs kafkadata/:uid/:phone/:id/:msg/:type
		
		/*http://localhost:5000/gatewayc2/kafkadata/N9MEBzezdJRNTTfUfZ02KcKH77H3/+15103150928/PNaeea8405be8bc49e1445d261dce14f5b/Calling%20+916379112113/Dialer*/
		
		
		 var self=this;
		 var msg= 'Calling ' + n;
		 var urlnew=`${window.socketendpoint}/gatewayc2/kafkadata/`+self.userid+`/`+self.dfrom+`/`+self.dtomenuid+`/`+msg+`/Dialer`; console.log('Log Url:',urlnew);
		 axios.get(urlnew, {} ).then(dataset => {	
			 console.log('Log Added');
		 }).catch(err => { 
			 console.log('Log Error');
		 })
		
		
		
		
      } else {
        // hang up call in progress
        Twilio.Device.disconnectAll();
		this.currentNumber='';
      }
    },

    // Handle numeric buttons
    sendDigit: function(digit) {
		console.log(digit);
       // 
	   if(this.connection){
		  this.connection.sendDigits(digit); 
	   }else{
		 var  previousdigit=this.currentNumber+digit;
		 this.currentNumber=previousdigit;
	   }
    },removeDigit: function() {
	 	 var  previousdigit=this.currentNumber;
		 this.currentNumber=previousdigit.slice(0, -1);
    }

  }
}
</script>
 
 
<style>
    #dialer {
        font-family: Helvetica, sans-serif;
        margin: 0px auto;
        width: 250px;
		text-align: center;
		/*background-color: #eee;*/
		padding: 5px;
		border-radius: 5px;
			background: rgba(226,226,226,1);
    }
    [v-cloak] {
      display: none;
    }
	.btn-default {
		color: #333;
		background-color: #fff;
		border-color: #ccc;
	}
	.btn-default.focus, .btn-default:focus {
    	color: #333;
		background-color: #e6e6e6;
		border-color: #8c8c8c;
	}
	.btn.focus, .btn:focus, .btn:hover {
		color: #333;
		text-decoration: none;
	}
	.btn-circle {
		width: 49px;
		height: 49px;
		text-align: center;
		padding: 5px 0;
		font-size: 20px;
		line-height: 2.00;
		border-radius: 30px;
	}
	.alpha{
	display:none!important;
	}
	.dropdown-toggle::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: .255em;
    vertical-align: .0em;
    content: "";
    border-top: 0.5em solid;
    border-right: 0.5em solid transparent;
    border-bottom: 0;
    border-left: .5em solid transparent;
}
.backremove{
 width: 30px;height: 30px;border: none;margin-top: 8px;float: left;display: block; cursor:pointer;
}
.key-row button{
margin-left:10px;
margin-right:10px;
}
.num::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
 
    opacity: 0.5; /* Firefox */
	font-size: 20px;
	font-weight: 400;
}
.num { /* Chrome, Firefox, Opera, Safari 10.1+ */
    opacity: 1; /* Firefox */
	font-size: 20px; font-weight: 400;
}
.num::focus { 
   border:none;
}
.btn-success{
background-color:green;
}
.btn-danger{
background-color:red;
}
.bignum{
font-size:36px;
}
.dialnumclr{
/*background-color:#D81B60;*/
background-color:#fff;
color:#000;
border-color:#000;
}
  </style>



// WEBPACK FOOTER //
// src/components/Inbrowser/Dialer.vue